/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-13 18:44:42
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { getVisual } from '../../../controller';

const defaultColorValue = `
表头背景\t #154e7b
表头颜色\t #FFF
边框颜色\t #000
反感\t #154e7b
差评\t #8097b3
中立\t #d1cece
好评\t #ffe68d
推荐\t #ffbe00
`

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      tableColumns: [],
      tableList: [],
      tableColorList: [],
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('22').then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }


  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;
    const { columns: tableColumns, list: tableList} = parseArrayToTable(dataset, {
      handleColumn: (name) => ({
        title: name,
        style: {
          height: 38,
          fontSize: 20,
          textAlign: 'center',
          fontWeight: 500,
        },
        colStyle: {
          fontSize: 20,
          fontWeight: 500,
          textAlign: 'center',
          height: 30,
          color: '#000',
        },
      })
    })

    return {
      dataset,
      tableColumns,
      tableList,
    }
  }
 
  static parseChart = (dataset = []) => {
    const { axis: chartTitle, list: chartList } = dataset
      .map(item => item.slice(1))
      .reduce((acc, [name, value]) => {
        acc.axis.push(name);
        acc.list.push(value);
        return acc;
      }, { axis: [], list: [] }) 
    
    return { chartTitle, chartList }
  }

  static parseColor = (str) => {
    const dataset = parseStringToArray(str);
    const tableColorList = dataset.map(item => item[1]);
    
    return { tableColorList }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value, this.state.tableColorList);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const _color = Form.parseColor(value);
    const result = {
      ..._color,
      ...Form.parse(this.state.value, _color.tableColorList),
    }
    this.setState({
      colorValue: value,
      ...result,
    })

    typeof onChange === 'function' && onChange(result)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P22/Form.js